import * as core from '../../../../../../../core'

import { query } from './assets-by-los.query'

export const RESOURCE = {
  payload: {
    alias: 'assets.los.donut',
    description: 'Donut chart to display assets by Lane of Support',
    name: 'Assets by LOS',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
